module.exports = __webpack_public_path__ + "04_short_black.286c1c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_short_black.png
// module id = KpcS
// module chunks = 0